import { buildHeader, buildQueryParam } from "./baseService";
import { getJson } from "../utils/httpHelper";
import {CATEGORY_TYPE_OF_LIST} from "../constants/Category";

export const getAudiosByCategory = async (baseUrl, apiKey, tenantId, categoryId, params) => {
  const api = await fetch(buildQueryParam(`${baseUrl}/clients/aod-category/${categoryId}/audios/`, params), {
    headers: buildHeader(apiKey),
  });
  return getJson(api);
}

export const getAudioById = async (baseUrl, apiKey, uuid) => {
  let url = `${baseUrl}/media/single/${CATEGORY_TYPE_OF_LIST.Audio}/${uuid}/`;
  const accessCode = new URLSearchParams(window.location.search).get('access_code');
  if (accessCode) {
      url += `?access_code=${encodeURIComponent(accessCode)}`;
  }
  const api = await fetch(url, {
      headers: buildHeader(apiKey),
  });
  return getJson(api, {ignoreErrorTracing: true});
}
